import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, ProjectStrategicAxis, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  totalWeight: number;
  projectStrategicAxes: Identifiable<ProjectStrategicAxis>[];
  retrieveProjectStrategicAxes(
    request: Boundaries["retrieveProjectStrategicAxes"]["request"],
  ): void;
}

function useRetrieveProjectStrategicAxes(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectStrategicAxesRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectStrategicAxesRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectStrategicAxesRequestFailure(project),
    ),
    totalWeight: useSelector(() => selector.getProjectTotalWeight(project)),
    projectStrategicAxes: useSelector(() =>
      selector.getProjectStrategicAxes(project),
    ),
    retrieveProjectStrategicAxes: core.retrieveProjectStrategicAxes,
  };
}

export { useRetrieveProjectStrategicAxes };
